import CircleIcon from '@mui/icons-material/Circle';
import { Divider, Grid, List, ListItem, ListItemIcon } from '@mui/material';
import { WsColors, WsTypography, WsTypoVariants, WsTypoColors } from 'wisestep-base';

const PlanFeatureList = ({
  features,
}: {
  features: { feature: string; title: boolean; custom?: boolean }[];
}) => (
  <Grid item mt={2}>
    {features.map((feature, index) => (
      <List key={index} aria-label="feautes" sx={{ p: 0 }}>
        <ListItem>
          {feature?.custom ? (
            <WsTypography variant={WsTypoVariants.SUB_TITLE} bold color={WsTypoColors.PRIMARY}>
              {feature.feature}
            </WsTypography>
          ) : (
            <>
              <ListItemIcon sx={{ minWidth: '24px' }}>
                {!feature.title && (
                  <CircleIcon sx={{ fontSize: '12px', color: WsColors.GenericRichBlack }} />
                )}
                {feature.title && (
                  <WsTypography variant={WsTypoVariants.TITLE} bold color={WsTypoColors.PRIMARY}>
                    {feature.feature}
                  </WsTypography>
                )}
              </ListItemIcon>
              {!feature.title && (
                <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.BLACK}>
                  {feature.feature}
                </WsTypography>
              )}
            </>
          )}
        </ListItem>
        {feature.title && <Divider sx={{ width: '100%', mt: 1 }} />}
      </List>
    ))}
  </Grid>
);

export default PlanFeatureList;
